import { z } from 'zod';

export const deleteAgentSchema = z.object({
  agent_id: z.uuid('Invalid agent ID'),
});

export type DeleteAgentPayload = z.infer<typeof deleteAgentSchema>;
